import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AimThemeProvider } from '@zarya/theme';
import { WaitProvider, ToastProvider } from '@zarya/ui';
import { SessionProvider } from './app/auth/SessionProvider';
import { useLocale } from './app/i18n/useLocale';
import { createQueryClient } from './app/queryClient';
import { AppRoutes } from './routes';

const queryClient = createQueryClient();

export function App() {
  /**
   * O console inteiro repinta na troca de idioma (Onda C).
   *
   * `t()` é função de módulo, não contexto: nenhuma tela avisa o React de que o
   * texto mudou. Assinar aqui, na raiz, é o que faz uma escolha no menu do
   * usuário alcançar as telas — e é a razão de o seletor não precisar recarregar
   * a página.
   */
  const locale = useLocale();

  // `lang` do documento acompanha: é o que o leitor de tela usa para escolher a
  // voz, e o que o navegador usa para hifenização.
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return (
    <AimThemeProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ToastProvider>
            {/* Registro das ações demoradas do console inteiro, como o toast: as
                ordens ao middleware demoram (o Discovery chega a ~15 s no lab).
                Quem o mostra é o `TarefasEmExecucao` da topbar — sem travar a
                tela (29/08). Dentro do `ToastProvider`: o fecho de cada ação é
                um toast. */}
            <WaitProvider>
              {/* A sessão precisa do router: um 401 leva a T1 com `?retorno=` (FR-007). */}
              <SessionProvider>
                <AppRoutes />
              </SessionProvider>
            </WaitProvider>
          </ToastProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </AimThemeProvider>
  );
}
